import { Link } from '@cian/ui-kit';
import { IconActionArrowLeft24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './Layout.css';

interface IFormContentProps {
  main: React.ReactNode;
  aside?: React.ReactNode;
  bottom?: React.ReactNode | null;
}

export const Layout = ({ main, aside, bottom }: IFormContentProps) => (
  <div className={styles['container']}>
    <div className={styles['wrapper']}>
      <div className={styles['top']}>
        <Link
          href="/agentstva/"
          fontSize="S"
          beforeIcon={<IconActionArrowLeft24 color="icon-main-default" />}
          spacingSize="XS"
        >
          Каталог агентств
        </Link>
      </div>
      <div className={styles['content']}>
        <main className={styles['main']}>{main}</main>
        {aside && <aside className={styles['aside']}>{aside}</aside>}
      </div>
      {bottom && <div className={styles['bottom']}>{bottom}</div>}
    </div>
  </div>
);
